import {useCallback} from 'react'
import {useWatch} from 'react-hook-form'

import {useFieldConfigurationContext} from '../../configuration/useConfigurationContext'
import {useOrderProcessFormContext} from '../../form/useOrderProcessFormContext'

export const useConfirmationPin = () => {
  const {setValue, control, trigger} = useOrderProcessFormContext()
  const confirmationPin = useWatch({control, name: 'confirmationPin'})
  const {enableConfirmationPin} = useFieldConfigurationContext('confirmationPin')

  const setConfirmationPin = useCallback(
    async (pin: string) => {
      if (enableConfirmationPin) {
        setValue('confirmationPin', pin)
        await trigger()
      }
    },
    [setValue, trigger, enableConfirmationPin]
  )

  return {
    confirmationPin,
    setConfirmationPin,
    isConfirmationPinEnabled: enableConfirmationPin
  }
}
